/*
 * Custom sign calculator — classic page edition — Tailor Made Rooms
 *
 * Lives on the order page next to the Product Customizer form.
 * The form owns the questions and uploads; this script owns pricing and payment.
 *
 * What it does:
 *   1. "Figure your size and cost" expander: size in, live prices on all three materials.
 *   2. Picking a material auto-fills the form's Approx. Sign Size + Choice Material fields.
 *   3. Two payment buttons harvest EVERY form answer (files included) and post them
 *      with the right variant to /cart/add as multipart, so everything lands on the order.
 *
 * Rules that are not negotiable:
 *   - Never interpolate a price. No row in sign-pricing.json means no price.
 *   - Pay in full stays locked until the calculator has produced an exact price.
 *   - The $75 deposit always works, calculator or not.
 *   - Required form fields block BOTH buttons until filled (the deposit
 *     acknowledgement is only required on the deposit path).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-tmr-classic]');
  var paybox = document.querySelector('[data-tmr-paybox]');
  if (!root || !paybox) return;

  var CFG = {
    pricingUrl: root.dataset.pricingUrl,
    variantsUrl: root.dataset.variantsUrl,
    depositVariant: root.dataset.depositVariant,
    deposit: parseFloat(root.dataset.depositAmount) || 75,
    twoSided: parseFloat(root.dataset.twoSidedMultiplier) || 1.5
  };

  // How calculator materials speak the form's language
  var MAT_TO_APP = {
    metal: 'Aluminum (outdoors & Indoors)',
    canvas: 'Canvas (indoors)',
    acrylic: 'Acrylic (indoors)'
  };
  var MATERIALS = [
    { key: 'canvas',  name: 'Canvas',  use: 'Indoor only' },
    { key: 'metal',   name: 'Metal',   use: 'Indoor & outdoor' },
    { key: 'acrylic', name: 'Acrylic', use: 'Indoor only' }
  ];
  var SIZE_FIELD = 'properties[Size]';
  var MATERIAL_FIELD = 'properties[Material]';
  var DEPOSIT_ACK_FIELD = 'properties[Deposit FEE ONLY]';

  var $toggle = root.querySelector('[data-tmr-toggle]');
  var $panel = root.querySelector('[data-tmr-panel]');
  var $w = root.querySelector('[data-tmr-w]');
  var $h = root.querySelector('[data-tmr-h]');
  var $flip = root.querySelector('[data-tmr-flip]');
  var $sides = root.querySelectorAll('[data-tmr-sides]');
  var $result = root.querySelector('[data-tmr-result]');
  var $chosen = paybox.querySelector('[data-tmr-chosen]');
  var $payFull = paybox.querySelector('[data-tmr-payfull]');
  var $payDeposit = paybox.querySelector('[data-tmr-paydeposit]');
  var $payErr = paybox.querySelector('[data-tmr-payerr]');

  var INDEX = {}, LIST = [], VARIANTS = {}, ready = false;
  var state = { w: parseInt($w.value, 10) || 0, h: parseInt($h.value, 10) || 0, sides: 1, chosen: null, busy: false };

  // ------------------------------------------------------------ data
  Promise.all([
    fetch(CFG.pricingUrl).then(function (r) { return r.json(); }),
    fetch(CFG.variantsUrl).then(function (r) { return r.json(); }).catch(function () { return {}; })
  ]).then(function (res) {
    buildIndex(res[0]);
    VARIANTS = (res[1] && res[1].variants) ? res[1].variants : (res[1] || {});
    ready = true;
    render();
  }).catch(function () {
    $result.innerHTML = '<div class="tmr-note tmr-note-quiet">Prices are loading — if this doesn\'t clear, call us on <a href="tel:16168972070">1‑616‑897‑2070</a>.</div>';
  });

  function buildIndex(data) {
    if (data && data.meta && data.meta.rules && data.meta.rules.two_sided_multiplier) {
      CFG.twoSided = data.meta.rules.two_sided_multiplier;
    }
    (data.shapes || []).forEach(function (shape) {
      (shape.sizes || []).forEach(function (row) {
        var parts = String(row.size).split('x');
        var w = parseInt(parts[0], 10), h = parseInt(parts[1], 10), key = w + 'x' + h;
        if (!INDEX[key]) { INDEX[key] = { w: w, h: h, key: key, canvas: null, metal: null, acrylic: null }; LIST.push(INDEX[key]); }
        var e = INDEX[key];
        ['canvas', 'metal', 'acrylic'].forEach(function (m) {
          var v = row[m];
          if (v == null) return;
          if (e[m] == null) { e[m] = v; } else if (e[m] !== v) { e[m] = Math.min(e[m], v); }
        });
      });
    });
    if (document.querySelector('[data-tmr-all-sizes]')) renderSizeTable();
  }

  // ------------------------------------------------------------ helpers
  function money(n) {
    var s = Math.round(n * 100) / 100;
    var str = s % 1 === 0 ? s.toFixed(0) : s.toFixed(2);
    return '$' + str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  // Plain words for the validation message - raw property names confuse people
  // (owner + a customer both failed on "Deposit FEE ONLY", 2026-10-18).
  var FRIENDLY_LABELS = {
    'Deposit FEE ONLY': 'tap the circle "I know this is a deposit ONLY" (highlighted above)',
    'Schedule a Creative Consult': 'choose Yes or No under "Schedule a Creative Consult"',
    'Mounting Choice': 'pick a Mounting Choice',
    'Style': 'pick a Style',
    'Size': 'type your size in the "Approx. Size" box',
    'Material': 'choose a Material',
    'Color Theme': 'fill in your Color Theme',
    'Give Us the Details': 'fill in "Give Us the Details"'
  };

  // A locked button that explains itself beats a dead one. aria-disabled keeps
  // the click alive so we can say WHY; the CSS below keeps the dimmed look.
  (function injectCss() {
    var st = document.createElement('style');
    st.textContent =
      '[data-tmr-payfull][aria-disabled="true"]{opacity:.55;cursor:not-allowed;}' +
      '.tmr-flash{outline:3px solid #BE1E2D !important;outline-offset:4px;border-radius:6px;' +
      'animation:tmrPulse 1.1s ease-in-out 2;}' +
      '@keyframes tmrPulse{50%{outline-color:transparent;}}' +
      '[data-tmr-payerr]{font-size:1.05em;font-weight:700;}';
    document.head.appendChild(st);
  })();

  function setLocked(btn, locked) {
    btn.disabled = false; // the native attribute swallows clicks; aria-disabled locks politely
    if (locked) { btn.setAttribute('aria-disabled', 'true'); }
    else { btn.removeAttribute('aria-disabled'); }
  }
  function isLocked(btn) { return btn.getAttribute('aria-disabled') === 'true'; }

  function flash(el) {
    if (!el) return;
    el.classList.add('tmr-flash');
    setTimeout(function () { el.classList.remove('tmr-flash'); }, 2600);
  }

  function openCalculator() {
    if ($panel && $panel.hasAttribute('hidden')) {
      $panel.removeAttribute('hidden');
      root.classList.add('tmr-open');
      if ($toggle) $toggle.setAttribute('aria-expanded', 'true');
    }
    root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    flash(root);
  }
  function priceFor(row, mat) {
    var base = row[mat];
    if (base == null) return null;
    return state.sides === 2 ? base * CFG.twoSided : base;
  }
  function variantFor(row, mat) { return VARIANTS[row.key + '|' + mat + '|' + state.sides] || null; }
  function lowest(row) {
    var v = [row.canvas, row.metal, row.acrylic].filter(function (x) { return x != null; });
    return v.length ? Math.min.apply(null, v) : null;
  }
  function nearest(w, h, n) {
    return LIST.slice().map(function (r) {
      return { row: r, d: Math.min(Math.abs(r.w - w) + Math.abs(r.h - h), Math.abs(r.w - h) + Math.abs(r.h - w)) };
    }).sort(function (a, b) { return a.d - b.d; }).slice(0, n)
      .sort(function (a, b) { return (a.row.w * a.row.h) - (b.row.w * b.row.h); })
      .map(function (x) { return x.row; });
  }

  // ------------------------------------------------------------ events
  if ($toggle) $toggle.addEventListener('click', function () {
    var open = !$panel.hasAttribute('hidden');
    if (open) { $panel.setAttribute('hidden', ''); } else { $panel.removeAttribute('hidden'); }
    $toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    root.classList.toggle('tmr-open', !open);
  });
  $w.addEventListener('input', function () { state.w = parseInt($w.value, 10) || 0; render(); });
  $h.addEventListener('input', function () { state.h = parseInt($h.value, 10) || 0; render(); });
  if ($flip) $flip.addEventListener('click', function () {
    var t = state.w; state.w = state.h; state.h = t;
    $w.value = state.w; $h.value = state.h;
    render();
  });
  Array.prototype.forEach.call($sides, function (b) {
    b.addEventListener('click', function () {
      state.sides = parseInt(b.dataset.tmrSides, 10);
      if (state.chosen) { state.chosen = null; syncPaybox(); }
      render();
    });
  });

  // ------------------------------------------------------------ render
  function render() {
    if (!ready) return;
    Array.prototype.forEach.call($sides, function (b) {
      b.setAttribute('aria-pressed', parseInt(b.dataset.tmrSides, 10) === state.sides ? 'true' : 'false');
    });
    if (!state.w || !state.h) {
      $result.innerHTML = '<div class="tmr-note tmr-note-quiet">Enter a width and a height to see prices on all three materials.</div>';
      return;
    }
    var row = INDEX[state.w + 'x' + state.h];
    if (row) { renderMatch(row); } else { renderNoMatch(); }
  }

  function renderMatch(row) {
    var html = '<div class="tmr-matlist" role="group" aria-label="Choose a material">';
    MATERIALS.forEach(function (m) {
      var p = priceFor(row, m.key);
      if (p == null) {
        html += '<button class="tmr-mat" type="button" disabled>' +
          '<span><span class="tmr-mat-name">' + m.name + '</span>' +
          '<span class="tmr-mat-use">Not offered at this size</span></span>' +
          '<span class="tmr-mat-na">—</span></button>';
      } else {
        var picked = state.chosen && state.chosen.key === row.key && state.chosen.mat === m.key && state.chosen.sides === state.sides;
        html += '<button class="tmr-mat" type="button" data-mat="' + m.key + '" aria-pressed="' + !!picked + '">' +
          '<span><span class="tmr-mat-name">' + m.name + '</span>' +
          '<span class="tmr-mat-use">' + esc(m.use) + '</span></span>' +
          '<span class="tmr-mat-price">' + money(p) + '</span></button>';
      }
    });
    html += '</div><p class="tmr-pick-hint">Tap a material to use it for your sign.</p>';
    $result.innerHTML = html;
    Array.prototype.forEach.call($result.querySelectorAll('[data-mat]'), function (b) {
      b.addEventListener('click', function () { choose(row, b.getAttribute('data-mat')); });
    });
  }

  function renderNoMatch() {
    var w = state.w, h = state.h;
    var flipped = INDEX[h + 'x' + w];
    var html = '';
    if (flipped) {
      html += '<div class="tmr-note tmr-note-flip"><strong>' + w + ' × ' + h + '″ isn\'t on our price list, but ' + h + ' × ' + w + '″ is.</strong>' +
        '<div style="margin-top:8px"><button class="tmr-chip" type="button" data-goflip="1">⇆ Use ' + h + ' × ' + w + '″ — from ' + money(lowest(flipped)) + '</button></div></div>';
    } else {
      html += '<div class="tmr-note tmr-note-quiet"><strong>We don\'t price ' + w + ' × ' + h + '″ off the shelf.</strong> Closest sizes below — or type your size in the form and start with the $75 deposit, and we\'ll price it together.</div>';
    }
    html += '<div class="tmr-chips">';
    nearest(w, h, 8).forEach(function (r) {
      html += '<button class="tmr-chip" type="button" data-size="' + r.key + '">' + r.w + ' × ' + r.h + '″ <span>from ' + money(lowest(r)) + '</span></button>';
    });
    html += '</div>';
    $result.innerHTML = html;
    Array.prototype.forEach.call($result.querySelectorAll('[data-size]'), function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-size').split('x');
        state.w = parseInt(k[0], 10); state.h = parseInt(k[1], 10);
        $w.value = state.w; $h.value = state.h;
        render();
      });
    });
    var gf = $result.querySelector('[data-goflip]');
    if (gf) gf.addEventListener('click', function () {
      var t = state.w; state.w = state.h; state.h = t;
      $w.value = state.w; $h.value = state.h;
      render();
    });
  }

  // ------------------------------------------------------------ choose → fill the form
  function choose(row, mat) {
    var price = priceFor(row, mat);
    if (price == null) return;
    state.chosen = { key: row.key, w: row.w, h: row.h, mat: mat, sides: state.sides, price: price, variantId: variantFor(row, mat) };

    // speak the form's language
    var sizeEl = document.querySelector('[name="' + SIZE_FIELD + '"]');
    if (sizeEl) {
      sizeEl.value = row.w + '"w x ' + row.h + '"h';
      sizeEl.dispatchEvent(new Event('input', { bubbles: true }));
      sizeEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var matEl = document.querySelector('[name="' + MATERIAL_FIELD + '"]');
    if (matEl && MAT_TO_APP[mat]) {
      matEl.value = MAT_TO_APP[mat];
      matEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    render();
    syncPaybox();
    // fold the calculator away and take them to the questions
    if ($panel && !$panel.hasAttribute('hidden')) {
      $panel.setAttribute('hidden', '');
      root.classList.remove('tmr-open');
      if ($toggle) $toggle.setAttribute('aria-expanded', 'false');
    }
    var target = document.querySelector('.product-customizer-options') || paybox;
    target.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function matName(key) {
    return MATERIALS.filter(function (m) { return m.key === key; })[0].name;
  }

  function syncPaybox() {
    var c = state.chosen;
    if (c) {
      $chosen.innerHTML = '<span>Your sign: <b>' + c.w + ' × ' + c.h + '″ ' + matName(c.mat) + (c.sides === 2 ? ', two sided' : '') + '</b></span><b>' + money(c.price) + '</b>';
      $chosen.removeAttribute('hidden');
      if (c.variantId) {
        setLocked($payFull, false);
        $payFull.textContent = 'Pay in full — ' + money(c.price);
      } else {
        setLocked($payFull, true);
        $payFull.textContent = 'Pay in full — this size is deposit-only for now';
      }
      $payDeposit.textContent = 'Put ' + money(CFG.deposit) + ' down to get the creative process started — ' + money(Math.max(0, c.price - CFG.deposit)) + ' due after you approve the design';
    } else {
      $chosen.setAttribute('hidden', '');
      setLocked($payFull, true);
      $payFull.textContent = 'Pay in full — use the calculator above to get your price';
      $payDeposit.textContent = 'Put ' + money(CFG.deposit) + ' down to get the creative process started';
    }
  }

  // ------------------------------------------------------------ the form: validate + harvest
  function formFields() {
    return Array.prototype.slice.call(document.querySelectorAll('[name^="properties["]'));
  }

  function fieldLabel(name) {
    var raw = name.replace(/^properties\[/, '').replace(/\]$/, '');
    for (var key in FRIENDLY_LABELS) {
      if (raw === key || raw.indexOf(key) === 0) return FRIENDLY_LABELS[key];
    }
    return 'fill in "' + raw + '"';
  }

  function missingRequired(skipDepositAck) {
    var missing = [], seenRadio = {};
    formFields().forEach(function (el) {
      var name = el.getAttribute('name');
      if (skipDepositAck && name === DEPOSIT_ACK_FIELD) return;
      var required = el.required || el.getAttribute('aria-required') === 'true';
      if (!required) return;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (seenRadio[name]) return;
        seenRadio[name] = true;
        var group = document.querySelectorAll('[name="' + name + '"]');
        var any = false;
        Array.prototype.forEach.call(group, function (r) { if (r.checked) any = true; });
        if (!any) missing.push({ name: name, el: el });
      } else if (el.type === 'file') {
        if (!el.files || el.files.length === 0) missing.push({ name: name, el: el });
      } else {
        if (!String(el.value || '').trim()) missing.push({ name: name, el: el });
      }
    });
    return missing;
  }

  function harvest(fd, skipDepositAck) {
    var seen = {};
    formFields().forEach(function (el) {
      var name = el.getAttribute('name');
      if (skipDepositAck && name === DEPOSIT_ACK_FIELD) return;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.checked) fd.append(name, el.value);
      } else if (el.type === 'file') {
        if (el.files) Array.prototype.forEach.call(el.files, function (f) { fd.append(name, f); });
      } else {
        if (seen[name]) return;
        seen[name] = true;
        var v = String(el.value || '').trim();
        if (v) fd.append(name, v);
      }
    });
  }

  function showError(msg) {
    $payErr.textContent = msg;
    $payErr.removeAttribute('hidden');
  }
  function clearError() { $payErr.setAttribute('hidden', ''); }

  function validateOrExplain(skipDepositAck) {
    var missing = missingRequired(skipDepositAck);
    if (!missing.length) { clearError(); return true; }
    showError('Almost there — ' + missing.map(function (m) { return fieldLabel(m.name); }).join(', and '));
    var el = missing[0].el;
    var target = el.closest('.product-customizer-option') || el;
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    flash(target);
    if (el.type !== 'file') { try { el.focus({ preventScroll: true }); } catch (e) {} }
    return false;
  }

  // ------------------------------------------------------------ payment
  $payFull.addEventListener('click', function () {
    if (state.busy) return;
    var c = state.chosen;
    if (!c) {
      // The locked button explains itself instead of playing dead.
      showError('First set your price: the calculator is opening above — enter your size and tap a material, and this button unlocks with your exact price.');
      openCalculator();
      return;
    }
    if (!c.variantId) {
      showError('This size is priced with you personally — start with the $75 deposit below and we will price it together.');
      flash($payDeposit);
      return;
    }
    if (!validateOrExplain(true)) return;
    var fd = new FormData();
    fd.append('id', c.variantId);
    fd.append('quantity', '1');
    harvest(fd, true);
    fd.append('properties[Exact Size]', c.w + ' x ' + c.h + ' inches');
    fd.append('properties[Sides]', c.sides === 2 ? 'Two sided' : 'One sided');
    submit(fd, $payFull);
  });

  $payDeposit.addEventListener('click', function () {
    if (state.busy) return;
    if (!validateOrExplain(false)) return;
    var fd = new FormData();
    fd.append('id', CFG.depositVariant);
    fd.append('quantity', '1');
    harvest(fd, false);
    var c = state.chosen;
    if (c) {
      fd.append('properties[Exact Size]', c.w + ' x ' + c.h + ' inches');
      fd.append('properties[Sides]', c.sides === 2 ? 'Two sided' : 'One sided');
      fd.append('properties[Quoted total]', money(c.price));
      fd.append('properties[Balance due after approval]', money(Math.max(0, c.price - CFG.deposit)));
    }
    submit(fd, $payDeposit);
  });

  function submit(fd, btn) {
    state.busy = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add', { method: 'POST', body: fd }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = '/cart';
    }).catch(function () {
      state.busy = false;
      btn.disabled = false;
      btn.textContent = label;
      showError('That didn\'t go through. Try again, or call us on 1‑616‑897‑2070.');
    });
  }

  // ------------------------------------------------------------ size table
  function renderSizeTable() {
    var tb = document.querySelector('[data-tmr-all-sizes]');
    if (!tb) return;
    var rows = LIST.slice().sort(function (a, b) { return (a.w * a.h) - (b.w * b.h); });
    tb.innerHTML = rows.map(function (r) {
      function cell(v) { return v == null ? '<td class="tmr-na">not offered</td>' : '<td>' + money(v) + '</td>'; }
      return '<tr><td>' + r.w + ' × ' + r.h + '</td>' + cell(r.canvas) + cell(r.metal) + cell(r.acrylic) + '</tr>';
    }).join('');
  }

  syncPaybox();
})();
